import { Link } from "@tanstack/react-router";
import React from "react";

interface Props {
  externalCreatedBy?: string;
  createdBy?: string;
  [key: string]: any;
}

export const CreatorLink: React.FC<Props> = ({ externalCreatedBy, createdBy, ...rest }) => {
  // If external created by exist, prioritize it
  const username = externalCreatedBy || createdBy;
  const isExternal = externalCreatedBy !== undefined;
  if (!username) return null;

  const baseStyles =
    "text-tx-tertiary line-clamp-1 truncate mb-2 w-full text-md font-semibold transition duration-300 ease-out hover:underline";

  return (
    <Link
      to="/profile"
      search={isExternal ? { externalUsername: username } : { username }}
      onPointerDownCapture={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={baseStyles}
      {...rest}
    >
      @{username}
    </Link>
  );
};
